<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xl-3">
            <label>{{ 'FROM' | translate }}</label>
            <app-datepickr [defaultDate]="filterFrom" [displayMonths]="1" (onSelect)="filterFrom = $event"></app-datepickr>
          </div>
          <div class="col-xl-3">
            <label>{{ 'TO' | translate }}</label>
            <app-datepickr [defaultDate]="filterTo" [displayMonths]="1" (onSelect)="filterTo = $event"></app-datepickr>
          </div>
          <div class="col-xl-3">
            <label>{{ 'CUSTOMER_COMMERCIAL' | translate }}</label>
            <ng-select [(ngModel)]="filterCommercial" (clear)="filterCommercial = ''" [clearable]="filterCommercial !== ''" [searchable]="false">
              <ng-option [value]="''">{{ 'ALL' | translate }}</ng-option>
              <ng-option *ngFor="let comm of commercialUsers" [value]="comm.hash">{{ comm.complete_name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 pt-05">
            <button type="button" class="mt-1 btn btn-outline-primary" (click)="loadStats()">{{ 'FILTER' | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-8 col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ "GRAPH" | translate }}</h3>
          </div>
          <div class="card-body pl-0" *ngIf="loadedStats && statistics">
            <div class="px-2">
              <app-step-counter icon="trending-up" title="TOTAL_INSERTED_REQUEST" [count]="statistics.counter_request"></app-step-counter>
            </div>
            <apx-chart
              [series]="chartSeries"
              [chart]="{type: 'bar', height: 430, toolbar: {show: false}}"
              [dataLabels]="barsChartOptions.dataLabels"
              [stroke]="{width: 1, colors: ['#fff']}"
              [colors]="['#82868A', '#FF9E43', '#03CFE7', '#EA5354', '#28C76F', '#FF6600', '#28C76F']"
              [plotOptions]="{bar: { barHeight: '100%', distributed: true, horizontal: true, dataLabels: { position: 'bottom' }}}"
              [yaxis]="{ labels: { show: false } }"
              [xaxis]="{ categories: [
                         ('STEPS_STATS.SUITABLES' | translate),
                         ('STEPS_STATS.PROPOSED' | translate),
                         ('STEPS_STATS.CALLS' | translate),
                         ('STEPS_STATS.KO' | translate),
                         ('STEPS_STATS.OK' | translate),
                         ('STEPS_STATS.BARGAININGS' | translate),
                         ('STEPS_STATS.HIRED' | translate)
              ] }"
              [tooltip]="barsChartOptions.tooltip"
            ></apx-chart>
            <p *ngIf="!statistics && !loadedStats" class="pl-2">{{ 'LOADING_CHART' | translate }}</p>
            <p *ngIf="loadedStats && !statistics" class="pl-2">{{ 'NO_STATISTICS_FOR_SELECTED_COMMERCIAL' | translate }}</p>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ "COUNTER" | translate }}</h3>
          </div>
          <div class="card-body pb-1">
            <ng-container *ngIf="statistics && loadedStats">
              <app-step-counter icon="thumbs-up" title="SUITABLES" [count]="statistics.counter_step_0"></app-step-counter>
              <app-step-counter icon="arrow-up-right" title="PROPOSED" [count]="statistics.counter_step_1" color="warning"></app-step-counter>
              <app-step-counter icon="phone-call" title="CALLS" [count]="statistics.counter_step_2_3" color="info"></app-step-counter>
              <app-step-counter icon="x" title="KO" [count]="statistics.counter_step_4" color="danger"></app-step-counter>
              <app-step-counter icon="check" title="OK" [count]="statistics.counter_step_5" color="success"></app-step-counter>
              <app-step-counter icon="file-text" title="BARGAININGS" [count]="statistics.counter_step_6" color="primary"></app-step-counter>
              <app-step-counter icon="award" title="HIRED" [count]="statistics.counter_step_7" color="success"></app-step-counter>
            </ng-container>
            <p *ngIf="!statistics && !loadedStats">{{ 'LOADING_COUNTER' | translate }}</p>
            <p *ngIf="loadedStats && !statistics">{{ 'NO_STATISTICS_FOR_SELECTED_COMMERCIAL' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>